import { Controller } from "stimulus"

// Triggers AI response for new learning threads after the page loads
// and Turbo Stream connections are established
export default class extends Controller {
  static values = {
    messageId: String
  }

  connect() {
    // Reset triggered flag on each connect to handle page navigations
    this.triggered = false
    console.log('[LearningThreadInit] Controller connected, messageId:', this.messageIdValue)

    if (this.messageIdValue) {
      // Delay to ensure Turbo Stream WebSocket is connected
      // This needs to be long enough for the connection to establish
      setTimeout(() => this.triggerResponse(), 1500)
    }
  }

  triggerResponse() {
    if (this.triggered) {
      console.log('[LearningThreadInit] Already triggered, skipping')
      return
    }
    this.triggered = true
    console.log('[LearningThreadInit] Triggering response for message:', this.messageIdValue)

    const csrfMeta = document.querySelector('meta[name="csrf-token"]')
    const csrfToken = csrfMeta ? csrfMeta.content : ''

    fetch('/chats/threads/trigger_learning_response', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ message_id: this.messageIdValue })
    })
    .then(response => {
      console.log('[LearningThreadInit] Trigger response status:', response.status)
    })
    .catch(function(error) {
      console.error('[LearningThreadInit] Failed to trigger learning response:', error)
    })
  }
}
